// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-block__title[data-v-4a8a4275]{font-size:18px;font-weight:700;color:#141c20;margin-bottom:5px}.form-block__description[data-v-4a8a4275]{line-height:1.37;font-size:14px;color:#7c8b91}.form-block .json-schema-form[data-v-4a8a4275]{margin-top:18px}", ""]);
// Exports
module.exports = exports;
